module.exports = __webpack_public_path__ + "static/media/PdfIcon.725dc2d5.svg";